const state = {
  menuSet: [
    { text: 'Cursos Grátis', url: '#', colorSecondary: true },
    { text: 'Aulas ao vivo', url: '#', colorSecondary: true },
    { text: 'Negócios', url: '#' },
    { text: 'Design e Vídeo', url: '#' },
    { text: 'Marketing Digital', url: '#' },
    { text: 'Finanças', url: '#' },
    { text: 'Habilidades Lucrativas', url: '#' },
    { text: 'Outras Áreas', url: '#' },
  ],
  footerMenuSet: [
    [
      { text: 'Página inicial', to: {name: 'home'} },
    ], [
      { text: 'Termos de Uso', to: {name: 'legal.terms'} },
    ], [
      { text: 'Política de Privicidade', to: {name: 'legal.privacy'} },
    ], [
      { text: 'Central de Ajuda', to: {name: 'support'} },
    ],
  ],
  isSideMenuVisible: false
}

const mutations = {
  setSideMenuVisible (state) {
    state.isSideMenuVisible = true
  },
  setSideMenuInvisible (state) {
    state.isSideMenuVisible = false
  }
}

const actions = {
}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
